module.exports = __webpack_public_path__ + "static/media/YOUNG.3040bc41.svg";